import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const InputIconTailwindThemes = {
  inputicon: {
    root: ({ context }: PrimeReactStylesFunctionType) => ({
      className: classNames('absolute top-1/2 -mt-1.75 text-sm text-fletchers-gray-200', {
        'left-2': context.iconPosition === 'left',
        'right-2': context.iconPosition === 'right',
      }),
    }),
  },
};
